import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Facebook, Twitter, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_spotless-shine/artifacts/al9d6a8y_IMG-20260112-WA0006.jpg" 
                alt="A Team Cleaning Service Logo"
                className="h-12 w-12 object-contain"
              />
              <span className="text-xl font-bold text-white">A Team Cleaning</span>
            </Link>
            <p className="text-sm mb-4">
              Professional cleaning services you can trust. Making your space sparkle since 2010.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-blue-400 rounded-lg flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-yellow-500 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-yellow-500 transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/booking" className="hover:text-yellow-500 transition-colors">Book Now</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-yellow-500 transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-yellow-500 transition-colors cursor-pointer">Regular Cleaning</li>
              <li className="hover:text-yellow-500 transition-colors cursor-pointer">Deep Cleaning</li>
              <li className="hover:text-yellow-500 transition-colors cursor-pointer">Office Cleaning</li>
              <li className="hover:text-yellow-500 transition-colors cursor-pointer">Move In/Out</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-yellow-500" />
                <span>(437) 263-6134</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-yellow-500" />
                <span>ateammentainance@gmail.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-yellow-500" />
                <span>Mississauga, Ontario<br />Canada</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} A Team Cleaning Service. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;